import React from 'react';

export interface SparkIconProps {
    /** Edge length in px. Inherits `currentColor` either way. */
    size?: number;
    className?: string;
}

/**
 * The Maper four-point spark. It marks what the platform itself contributes rather than what a
 * person did — the Pro tier on a feature, the assistant's voice in a conversation.
 */
const SparkIcon: React.FC<SparkIconProps> = ({ size = 12, className }) => (
    <svg
        width={size}
        height={size}
        viewBox="142 224 292 292"
        fill="currentColor"
        aria-hidden="true"
        className={className}
    >
        <path d="M142.62,371.2c85.4-12.51,132.82-62.17,145.69-146.92c0.86,4.9,1.58,9.83,2.61,14.69c7.28,34.37,20.39,65.74,46.56,90.41c22.4,21.11,49.33,32.94,79.21,38.7c5.47,1.05,11.02,1.69,16.76,3.01c-84.48,11.66-132.43,59.95-145.6,144.19C274.19,431.83,226.44,383.28,142.62,371.2z" />
    </svg>
);

export default SparkIcon;
